import generateCopiesList from '../../_cart/generate-copies-list';

class QuantityPricingTools {
  constructor({
    useSetsWherePossible, productSetCopies, unitPrices, perPagePrices
  }) {
    this.useSetsWherePossible = useSetsWherePossible;
    this.productSetCopies = productSetCopies;
    this.unitPrices = unitPrices;
    this.perPagePrices = perPagePrices;
  }

  get copiesList() {
    if (this.isUsingSets) {
      return generateCopiesList(this.productSetCopies);
    }

    return generateCopiesList();
  }

  generateOptions(productName) {
    return this.copiesList.map((quantity) => {
      const unitPrice = this.getUnitPriceForQuantity(quantity);
      const product = (() => {
        if (productName) {
          return quantity == 1 ? productName : `${productName}s`;
        }
        return quantity == 1 ? 'copy' : 'copies';
      })();
      return {
        quantity,
        unitPrice,
        cost: quantity * unitPrice,
        product,
      };
    });
  }

  getUnitPriceForQuantity(quantity) {
    return this.unitPrices.find((currentTier, i, unitPrices) => {
      const nextTier = unitPrices[i + 1] || { from: 1 };

      return (currentTier.from <= quantity && nextTier.from > quantity) || i === (unitPrices.length - 1);
    }).price;
  }

  currentOrFirstAvailableCopies(previousValue) {
    const _copiesList = this.copiesList;

    if (!_copiesList.some((c) => c == previousValue)) {
      // the previous quantity isn't in the
      // latest list of availableCopies
      return _copiesList[0];
    }

    return previousValue;
  }

  get isUsingSets() {
    return this.useSetsWherePossible && this.productSetCopies;
  }
}

export default QuantityPricingTools;
